export default __webpack_public_path__ + "static/web-image-mg360-03-1-6e24e60b6594523be98c2116d6cbe1fb.png";